import React, { memo, useState, useEffect } from "react";
import { Avatar, Space, Popover, message, Divider, Typography, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
// import { PermissionService } from "../Services/Permission/PermissionService";
import { useNavigate } from "react-router-dom";
import { notify } from "../components/Customs/NotifyProvider";
import { ENDPOINTS } from "../Services/ENDPOINT";

const { Text } = Typography;

const HeaderBar = () => {
  const navigate = useNavigate();

  const [omeUser, setOmeUser] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);


  // 🔁 Re-fetch user when popover opens
  useEffect(() => {
    if (popoverOpen) {
      const user = localStorage.getItem("user_key");

      console.log("user", user);

      setOmeUser(user);
    }
  }, [popoverOpen]);

  const handleReloadPermission = async () => {
    try {

      const user = localStorage.getItem("user_info");
      const parsedUser = JSON.parse(user);

      if (parsedUser.id) {
        const res = await fetch(`${ENDPOINTS.BASE}/users/${parsedUser.id}/permissions`, {
          method: "get",
        });
        const data = await res.json();

        if(!data.status){
          notify.error('error',  data.message || "Failed to fetch permissions Please login again.");
          return;
        }
        
        if (data.status === false) {
          notify.error('error',  data.message || "Failed to fetch permissions Please try again later.");
          return;
        }
        localStorage.setItem("user_permissions", JSON.stringify(data.data || []));
        notify.success("Permissions reloaded successfully!");

      } else {
        notify.error("User ID not found in user_info!");
      }

      console.log("user", JSON.parse(user).id);



      if (!user?.id) {
        message.error("User ID not found!");
        return;
      }
      let response;
      // const response = await PermissionService.getPermissionDetailsById(
      //   omeUser.uid
      // );

      // localStorage.setItem(
      //   "ome_permission",
      //   JSON.stringify(response.data.permissions)
      // );

      message.success("Permissions reloaded successfully!");
    } catch (error) {
      message.error("Failed to reload permissions.");
    }
  };

  const popoverContent = (
    <div style={{ minWidth: 250, padding: 10 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "120px 1fr",
          rowGap: 6,
        }}
      >
        <Text strong>USER MAIL</Text>
        <Text>{omeUser}</Text>
        {/* 
        <Text strong>Name:</Text>
        <Text>{omeUser?.name}</Text>

        <Text strong>Phone:</Text>
        <Text>{omeUser?.phone}</Text>

        <Text strong>Status:</Text>
        <Text>{omeUser?.status}</Text>

        <Text strong>Email:</Text>
        <Text>{omeUser?.email}</Text>

        <Text strong>Joined On:</Text>
        <Text>
          {omeUser?.added_on
            ? new Date(omeUser.added_on).toLocaleDateString()
            : "-"}
        </Text> */}
      </div>

      {/* <Divider /> */}

      {/* <Button
        block
        onClick={() => navigate("/profile")}
      >
        Edit
      </Button> */}

      <Divider style={{ margin: "8px 0" }} />

      <Button
        color="purple" variant="filled"
        block
        onClick={() => {
          handleReloadPermission();
        }}
      >
        Reload Permissions
      </Button>

      <Divider style={{ margin: "8px 0" }} />

      <Button
        block
        danger
        onClick={() => {
          localStorage.clear();
          window.location.reload();
        }}
      >
        Sign out
      </Button>
    </div>
  );

  return (
    <Space size="large">

      <Popover
        content={popoverContent}
        trigger="click"
        placement="bottom"
        open={popoverOpen}
        onOpenChange={setPopoverOpen}
      >
        <Avatar
          style={{ backgroundColor: "#87d068", cursor: "pointer" }}
          icon={<UserOutlined />}
        />
      </Popover>
    </Space>
  );
};

export default memo(HeaderBar);